import React from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, /*withProps*/ } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { fetchingState } from '../helpers/hocs.js'
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.ru';
import {sendDates} from '../store/reducers/visits';
//import page from 'page';
import moment from 'moment';
import Overlay from './Overlay'
import { getAllVisits } from '../store/reducers/visitsOfPerson.js'
import ContactToManager from './Visits/ContactToManager.jsx'
import BookDetect from './BookDetect.jsx'

const getTimesArray = (start, end) => {
    const arr = []
    for(let i = 0; i <= end; i++){
        arr.push(`${i % 2 === 0 ? i / 2 + start: (i-1) / 2 + start}:${i % 2 === 0 ? "00" : 30}`)
    }
    return arr
}

document.getElementsByTagName("body")[0].style.overflowY = "auto"


const VisitsCalendar = ({ visit, personId, getAllVisits, role, success, chooseDate, clearDate, eventDates=[], declinedDates = [], setDeclinedDate, showFormEventPopup,
    setFormEventPopup, currentDate=null, error=false, setError, errorTime, onTimeChangeHandler, time, addToDates, sendDatesofVisit,
    prepareDateTime, prepareDate, getDataRestourants, restaurantURL, setRestaurant, restaurants, booking, setBooking, tmpData, setInput, errorsData, place, address, placeName,
    setDate, onSave}) => {


    const setDates = (time) => {
        
        const [hours, minutes] = time.split(":")
        let choosedDate = new Date(currentDate);
        choosedDate.setTime(choosedDate.getTime() - choosedDate.getTimezoneOffset() * 60 * 1000);
        if(declinedDates.find(el => el.startDate.getTime() === new Date(new Date(choosedDate).setUTCHours(parseInt(hours)-3, parseInt(minutes))).getTime()) ){
            return;
        }

        if(eventDates.find(el => el.startDate.getTime() === new Date(new Date(choosedDate).setUTCHours(parseInt(hours)-3, parseInt(minutes))).getTime())){
            setDate(eventDates.filter(el => el.startDate.getTime() !== new Date(new Date(choosedDate).setUTCHours(parseInt(hours)-3, parseInt(minutes))).getTime()))
        } else {
            if(eventDates.length < 5){
            addToDates(time)
        }
        }
        
    }

    const compareDates = () => {
        let choosedDate = new Date(currentDate);
        choosedDate.setTime(choosedDate.getTime() - choosedDate.getTimezoneOffset() * 60 * 1000);
        const current = choosedDate.setUTCHours(0,0,0,0)
        const timesArr = []
    
        eventDates.forEach(el => {
            const test1 = new Date(el.startDate).setUTCHours(0,0,0,0)

            if(test1 === current){
                timesArr.push(`${el.startDate.getUTCHours()+3}:${String(el.startDate.getUTCMinutes()).length === 1 ? "0"+el.startDate.getUTCMinutes() : el.startDate.getUTCMinutes()}`)
            }
        })
        return timesArr
    }
    const compareDeclinedDates = () => {
        let choosedDate = new Date(currentDate);
        choosedDate.setTime(choosedDate.getTime() - choosedDate.getTimezoneOffset() * 60 * 1000);
        const current = choosedDate.setUTCHours(0,0,0,0)
        const timesArr = []
    
        declinedDates.forEach(el => {
            const test1 = new Date(el.startDate).setUTCHours(0,0,0,0)

            if(test1 === current){
                timesArr.push(`${el.startDate.getUTCHours()+3}:${String(el.startDate.getUTCMinutes()).length === 1 ? "0"+el.startDate.getUTCMinutes() : el.startDate.getUTCMinutes()}`)
            }
        })

        return timesArr
    }

    return isEmpty(visit)
    ? 
    null 
    :
    (//персона всегда видит календарь
        <div className='VisitsCalendar'>
            <div className='page-for-person'>
                <div className='visits-calendar'>
                    <h1 className='visits-calendar-title'>
                        Выбор даты и времени для встречи с меценатом {` ${visit.user.surname} ${visit.user.name}`}  
                    </h1>
                    <div className={`calendar-wrapper VisitsCalendar__wrapper ${((visit.visitDates.user && visit.visitDates.user.length > 0) || (visit.visitDates && visit.visitDates.tries && visit.visitDates.tries === 3)) ? '_blocked' : ''}`}>
                        <div>
                            {(!visit.visitDates.user || visit.visitDates.user.length === 0) && <div style={{margin: '5px 0'}}>Выберите наиболее удобные для вас даты</div>}
                            <Calendar 
                                minDate = {new Date()}
                                maxDate =  {moment(visit.is.created).add(3, 'month').toDate()} 
                                language = 'ru'
                                dataSource = {eventDates}
                                enableContextMenu = {true}
                                onDayClick={e => chooseDate(e)}
                            />
                        </div>
                       
                        <div className='VisitsCalendar__time'>
                            {
                                currentDate && eventDates &&
                                <div>
                                    <div>Выбранная дата: {prepareDate(currentDate)}</div>
                                    <div style={{margin: '5px 0 3px', textAlign: "start"}}><FormattedMessage id='moskow_time'/></div>
                                    <div className='VisitsCalendar__time-wrapper'>
                                        {
                                            getTimesArray(10, 20).map((el, index) => 
                                                <div 
                                                    key={`calendar-time-${index}`} 
                                                    className={compareDates().find(item => item === el) ? 'VisitsCalendar__time-item VisitsCalendar__time-item_selected' : 
                                                    (compareDeclinedDates().find(item => item === el) ? 'VisitsCalendar__time-item VisitsCalendar__time-item_declined' :'VisitsCalendar__time-item')} 
                                                    onClick={() => setDates(el)}>{el}
                                                </div>    
                                            )
                                        }
                                    </div>
                                </div>
                            }
                            
                        </div>

                        <div>
                            {(eventDates && eventDates.length > 0) &&
                                <div className='chooseDates'>
                                    <div className='chooseDates-title'>
                                        Выбранные даты {(visit.visitDates.user && visit.visitDates.user.length > 0) && <span>(выбор мецената, <FormattedMessage id='moskow_time'/>)</span>}
                                    </div>
                                    <div className='chooseDates__list'>
                                        {eventDates.map((date, i) => {
                                            return <span className='chooseDate' key={i}>{prepareDateTime(date.startDate)}</span>
                                        })}
                                    </div>
                                </div>
                            }

                            {(declinedDates && declinedDates.length > 0) &&
                                <div className='chooseDates'>
                                    <div className='chooseDates-title'>
                                        Отклонённые даты {(visit.visitDates.declined && visit.visitDates.declined.length > 0)}
                                    </div>
                                    <div className='chooseDates__list'>
                                        {declinedDates.map((date, i) => {
                                            return <span className='chooseDate' key={i}>{prepareDateTime(date.startDate)}</span>
                                        })}
                                    </div>
                                    { (visit.visitDates.userComment) && 
                                    <div className='chooseDates'>
                                        Комментарий мецената: "{visit.visitDates.userComment}"
                                    </div>
                                    }
                                    
                                </div>
                            }
                            {place && place.length > 0 &&
                            <div className='place chooseDates '>
                                {`Место встречи: ${place}`}
                            </div>
                            }

                            {(error && !showFormEventPopup) && <p className='Text GiftCardsCheck__text' style={{color: '#ff5027'}}>Пожалуйста, выберите 5 наиболее удобных для Вас дат! </p>}
                            
                            {((!visit.visitDates.user || visit.visitDates.user.length === 0) && (!visit.visitDates.tries || visit.visitDates.tries !== 3))  &&
                            <BookDetect
                                title='Кто будет делать бронь'
                                target='Хочу выбрать место встречи сам'
                                booking={booking}
                                setBooking={setBooking}
                                placeName={placeName}
                                address={address}
                                setInput={setInput}
                                errors={errorsData}
                            />
                            }
                            
                            {((!visit.visitDates.user || visit.visitDates.user.length === 0) && (!visit.visitDates.tries || visit.visitDates.tries !== 3))  && 
                                <div className='buttons-block'>
                                    <button className="Button Button_black _saveDate" onClick={async (e) => {
                                        const res = await sendDatesofVisit(e) 
                                        !!res && onSave()
                                    }}>Сохранить время встречи</button>
                                    {eventDates.length > 0 && <button className='Button Button_black' onClick={(e) => clearDate(e)} >Выбрать другие даты</button>}
                                </div>
                            }
                        </div>
                    </div>
                    {(visit.visitDates && visit.visitDates.tries && visit.visitDates.tries === 3)
                        ? 
                        <ContactToManager info={visit} role={role} classList='Button Button_black'/>
                        :
                        <ContactToManager info={visit} role={role} />
                    }
                </div>
                
                {/* <Overlay isActive={showFormEventPopup} onClose={()=> setFormEventPopup(false)} klassModifier='is--blured'>
                    {showFormEventPopup &&
                        <div className='EmailPopup'>
                            <h1 className='EmailPopup-h1 EmailPopup-h1-connection'><FormattedMessage id='time_confirm.connection' />: {currentDate.toLocaleDateString()}</h1>
                            <div className='EmailPopup-kontainer'>
                                <div className='EmailPopup-select'>
                                    <input 
                                        type="time"
                                        className='EmailPopup__field'
                                        name="time" 
                                        autoFocus
                                        min="00:00" max="23:59"
                                        onChange={(e) => onTimeChangeHandler(e)}
                                        value={time}
                                    />
                                </div>
                                {(errorTime && showFormEventPopup) && <p className='Text GiftCardsCheck__text'><FormattedMessage id='time_confirm.error' /></p>}
                                <button className='EmailPopup-submit' onClick={() => addToDates()}><FormattedMessage id='phone_confirm.done' /></button>
                            </div>
                        </div>
                    }
                </Overlay> */}
            </div>
        </div>
    )
}


const mapStateToProps = state => ({
  //info: state.visit.info,
})

const mapDispatchToProps = dispatch => bindActionCreators({sendDates, getAllVisits}, dispatch)

const mergeProps = (state, dispatch, props) => ({
    ...props,
    ...state,
    sendDates: (data) => {
        return(props.fetchingWrap(dispatch.sendDates.bind(this, data), 'send'))
    },
    updateVisits: () => {
        dispatch.getAllVisits()
    }
})


export default injectIntl(compose(
    withState('time', 'setTime', '00:00'),//время по умолчанию при выборе даты
    withState('errorTime', 'setErrorTime', false),//свойства ошибки, которые будут запрещать установку времени встречи, если она введена некорректно
    withState('error', 'setError', false),//свойство ошибки на попытку отправить меньше трех дат
    withState('currentDate', 'setCurrentDate', null),//получение текущей даты по клику в календаре
    withState('eventDates','setDate', []),//свойство хранящее наши даты, которые выбрала персона
    withState('declinedDates','setDeclinedDate', []),//свойство хранящее наши даты, которые выбрала персона
    withState('success', 'setSuccess', null),
    withState('showFormEventPopup', 'setFormEventPopup', false),//показывать или нет форму добавления даты встречи
    withState('restaurantURL', 'setRestaurant', null),
    withState('booking', 'setBooking', false),
    withState('tmpData', 'setTmpData', {}),
    withState('errorsData', 'setErrorsData', {}),//ошибка заполнения полей места встречи
    withState('place', 'setPlace', ''),//место встречи
    withState('address', 'setAddress', ''),//место встречи
    withState('placeName', 'setPlaceName', ''),//место встречи
    fetchingState({ multi: true }),
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    withHandlers({
        sendDatesofVisit: ({visit, data, updateVisits, setSuccess, eventDates, sendDates, error, setError,
            tmpData, booking, setErrorsData, setPlace}) => async (e) => {
            e && e.preventDefault();
            const dates = [];
            if (eventDates.length == 5) {//проверка хотя бы одна дата
                eventDates.forEach(item => {
                    //получаем полную дату встречи
                    dates.push(item.startDate);
                });

                data = {
                    visitId: visit._id,
                    dates: dates,
                    role: 'person',
                    booking: booking ? 'person' : 'user'
                };

                if (booking) {
                    let errors = {};
                    if (!tmpData.placeName || tmpData.placeName.length === 0) errors.placeName = true
                    if (!tmpData.place || tmpData.place.length === 0) errors.place = true
                    setErrorsData(errors)
                    if (Object.keys(errors).length > 0) return
                    data.placeName = tmpData.placeName
                    data.place = tmpData.place
                    setPlace(`${tmpData.place} - ${tmpData.placeName}`)
                }
                
                const result = await sendDates(data)
                if (result ===  200) {
                    setSuccess(true);
                    if (error) setError(false);
                    //здесь еще вызывать функцию получения данных о встречи, чтобы обновить состояние
                    await updateVisits()
                    setTimeout(() => {
                        setSuccess(null);
                        //page.redirect('/');
                    }, 3000);
                    return true
                }
            } else setError(true);
        },
        chooseDate: ({setFormEventPopup, setCurrentDate, eventDates}) => async (e) => {
            //вызываем метод при клике по дню в календаре
            setCurrentDate(e.date)//установка текущей даты
            setFormEventPopup(true);//показываем модальное окно
        },
        setInput: ({ setTmpData, tmpData, setAddress, setPlaceName }) => field => e => {//запись данных при записи в input
            tmpData[field] = e.target.value
            if (field === 'place')
                setAddress(e.target.value)
            if (field === 'placeName')
                setPlaceName(e.target.value)
            setTmpData(tmpData)
        },
        onTimeChangeHandler: ({setTime}) => (e) => {
            //ввод времени в модальном окне
            setTime(e.target.value)
        },
        addToDates: ({setDate, eventDates, setTime, currentDate, setCurrentDate, setFormEventPopup, setError, error, setErrorTime, errorTime}) => (time) => {
            //добавление объекта события встречи на указанную дату для отображения в календаре
            //извлекаем введенные в модальном окне часы и минуты, чтобы записать их в выбранную дату 
            //(по-умолчанию календарь добавляет дату со временем 00:00:00 по местному времени)
            const [hours, minutes] = time.split(':');

            const choosedDate = new Date(currentDate);
            //календарь по-умолчанию возвращает дату с 00:00 местного времени - нам нужно оперировать с датой 00:00 по UTC   
            const prepareDate = new Date(Date.UTC(choosedDate.getFullYear(), choosedDate.getMonth(), choosedDate.getDate()))
            
            if (time.length === 5) {
                const newDates = [...eventDates];
                const visitEvent = {//объект события встречи - делаем поправку на московское время
                    startDate: new Date(prepareDate.setUTCHours(parseInt(hours) - 3, parseInt(minutes))),
                    endDate: new Date(prepareDate.setUTCHours(parseInt(hours) - 3, parseInt(minutes)))
                };

                newDates.push(visitEvent);
                setDate(newDates);
                setFormEventPopup(false);//скрываем форму
                //сбрасываем все свойства нашего состояния
                // setCurrentDate(null)
                if (errorTime) setErrorTime(false)
                if (error) setError(false)
                // setTime('00:00')
            } else {
                setErrorTime(true)
            }
        },
        prepareDateTime: () => (item) => moment(item).utc().add(3, 'hours').format('DD.MM.YYYY HH:mm'),
        prepareDate: () => (item) => moment(item).format('DD.MM.YYYY'),
        clearDate: ({setDate, setCurrentDate}) => e => {
            e && e.preventDefault();
            setDate([])
            setCurrentDate(null)
        },
        getDataRestourants: (restaurants) => e => {
            e && e.preventDefault();
            //здесь будет подгрузка с данными по рестаранам
        },
    }),

    lifecycle({
        componentWillMount () {
            if (this.props.visit.visitDates && this.props.visit.visitDates.person && this.props.visit.visitDates.person.length > 0
                && (!this.props.visit.visitDates.user || this.props.visit.visitDates.user.length === 0)) {
                const savedDates = this.props.visit.visitDates.person.map(date => ({
                    startDate: new Date(date),
                    endDate: new Date(date),
                }))
                this.props.setDate(savedDates)
            }
            if (this.props.visit.visitDates && this.props.visit.visitDates.user && this.props.visit.visitDates.user.length > 0) {
                const savedDates = this.props.visit.visitDates.user.map(date => ({
                    startDate: new Date(date),
                    endDate: new Date(date),
                }))
                this.props.setDate(savedDates)
            }
            if (this.props.visit.visitDates && this.props.visit.visitDates.declined && this.props.visit.visitDates.declined.length > 0) {
                const savedDates = this.props.visit.visitDates.declined.map(date => ({
                    startDate: new Date(date),
                    endDate: new Date(date),
                }))
                this.props.setDeclinedDate(savedDates)
            } 
        },
        componentDidMount() {
            if (this.props.visit.place && this.props.visit.placeName) {
                this.props.setPlace(`${this.props.visit.place} - ${this.props.visit.placeName}`)
            }
        },
        componentWillUnmount () {
            this.props.setCurrentDate(null)
            this.props.setDate([])
            this.props.setErrorTime(false)
            this.props.setError(false)
            if (document.body.classList.contains('jivo-visible')) document.body.classList.remove('jivo-visible')
            window.jivo_destroy()
        },
        componentWillReceiveProps(np) {
            if (np.booking !== this.props.booking) {
                if (!np.booking) {
                    if (document.body.classList.contains('jivo-visible')) {
                        document.body.classList.remove('jivo-visible');
                        window.jivo_destroy();
                    }
                } else {
                    document.body.classList.add('jivo-visible')
                    window.jivo_init();
                    setTimeout(() => {
                        window.jivo_api.open();
                    }, 100);
                }
            }
        }
    })
)(VisitsCalendar))


// WEBPACK FOOTER //
// ./src/components/VisitCalendar.jsx